import { Component, Inject } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'rm-recall-report-dialog',
  templateUrl: './recall-report-dialog.component.html',
  styleUrls: ['./recall-report-dialog.component.css']
})
export class RecallReportDialogComponent implements OnInit {
  productId: string;
  gcp: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.productId = this.data.productId;
    this.gcp = this.data.gcp;
  }
}